import { useCallback, useEffect, useState } from "react";
import { getAudienceTags } from "src/services/AudienceListAPIs";

export const useAudienceTags = () => {
  const [tags, setTags] = useState<string[]>([]);
  const [availableTags, setAvailableTags] = useState<string[]>([]);

  useEffect(() => {
    let active = true;
    getAudienceTags()
      .then(response => {
        if (active) {
          const tags = (response.tags ?? []).map(tag => tag.trim()).filter(Boolean);
          setAvailableTags(Array.from(new Set(tags)));
        }
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, []);

  const addTag = useCallback((value: string) => {
    const tag = value.trim();
    if (!tag) {
      return;
    }
    setTags(prev =>
      prev.some(existing => existing.toLowerCase() === tag.toLowerCase()) ? prev : [...prev, tag]
    );
  }, []);

  const removeTag = useCallback((tag: string) => {
    setTags(prev => prev.filter(existing => existing !== tag));
  }, []);

  return { tags, availableTags, addTag, removeTag };
};
